import { jsx as _jsx } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ExtensionCard } from '../extension-card';
import { getExtensionStatus } from './extension-status';
import { createRoute } from '../../utils';
/**
 * The public {@link ExtensionCard} pointed at a management page instead of the marketplace: same
 * card, plus a gear affordance and — where the extension is not simply public — its publishing
 * state in place of the rating.
 */
export const ManageExtensionCard = ({ extension, routePrefix, linkState, iconPending, footerStart }) => {
    const status = getExtensionStatus(extension);
    // The namespace is the user's to claim, so the card flags it rather than just looking switched off.
    const needsAttention = Boolean(extension.namespaceOwnershipConflict);
    return (_jsx(ExtensionCard, { extension: extension, to: createRoute([routePrefix, extension.namespace, extension.name]), linkState: linkState, 
        // Greyscale would swallow the warning colour, and this state is the user's to fix —
        // it reads as actionable rather than switched off.
        dimmed: extension.active === false && !extension.namespaceOwnershipConflict, iconPending: iconPending, tone: needsAttention ? 'warning' : undefined, overlay: needsAttention ? (_jsx(WarningAmberIcon, { titleAccess: 'Needs attention', sx: { fontSize: '0.9375rem' } })) : (_jsx(SettingsOutlinedIcon, { sx: { fontSize: '0.9375rem' } })), footerStart: footerStart ??
            (status ? (_jsx(Typography, { component: 'span', sx: { fontSize: '0.75rem', fontWeight: 600, color: status.color }, children: status.label })) : undefined) }));
};
//# sourceMappingURL=manage-extension-card.js.map